(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["investor-page"] && !window.DesignMode) return;
  try {
    
  // Add a click event listener to the investor page
  document.querySelector('#investor-page').addEventListener('click', function (event) {
    // Get the mobile menu element
    let mobileMenu = document.querySelector('#investor-menu-mobile');

    // Check if the clicked target is not inside the mobile menu
    if (!mobileMenu.contains(event.target)) {
      // If the click is outside of the mobile menu, close it by setting the investor-menu-mobile-closed radio to checked
      let closeButton = document.querySelector('#investor-menu-mobile-closed');
      if (closeButton) {
        closeButton.checked = true;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-recommendations"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function (event) {
    const productRecommendationsSection = document.querySelector('#product-recommendations');

    const url = productRecommendationsSection.dataset.url;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('#product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-toolbar"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const formElement = document.querySelector('#main-product-form');
    const toolbarElement = document.querySelector('#main-product-toolbar');

    function moveElements() {
      const toolbarIsHidden =
        toolbarElement.classList.contains('hidden') || toolbarElement.style.display === 'none' ? true : false;

      const elements = [
        { selector: 'iframe#launcher', className: '-translate-y-16' },
        { selector: '#back-to-top', className: '-translate-y-12' },
        { selector: '#userwayAccessibilityIcon', className: 'translated' }
      ];

      elements.forEach(({ selector, className }) => {
        const element = document.querySelector(selector);
        if (!element) return;

        if (window.innerWidth < 768 && !toolbarIsHidden) {
          element.classList.add(className);
        } else {
          element.classList.remove(className);
        }
      });
    }

    const observer = new IntersectionObserver(function ([e]) {
      if (!e.isIntersecting) {
        toolbarElement.classList.remove('hidden');
        moveElements();
      } else {
        toolbarElement.classList.add('hidden');
        moveElements();
      }
    }, {});

    observer.observe(formElement);

    function debounce(func) {
      let timer;
      return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
      };
    }

    window.addEventListener('resize', debounce(moveElements));
  });

  } catch(e) { console.error(e); }
})();
})();
